export function cy(...args) {
  return args
    .filter((s) => typeof s === "string")
    .map((s) => s.split(" ").join("_"))
    .join("-")
    ?.toLowerCase();
}
